/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pale_Dark_Wolf_BurnInputs */

const en_pale_dark_wolf_burn = /** @type {(inputs: Pale_Dark_Wolf_BurnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deleting report...`)
};

const de_pale_dark_wolf_burn = /** @type {(inputs: Pale_Dark_Wolf_BurnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bericht wird gelöscht...`)
};

/**
* | output |
* | --- |
* | "Deleting report..." |
*
* @param {Pale_Dark_Wolf_BurnInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const pale_dark_wolf_burn = /** @type {((inputs?: Pale_Dark_Wolf_BurnInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pale_Dark_Wolf_BurnInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pale_dark_wolf_burn(inputs)
	return de_pale_dark_wolf_burn(inputs)
});